<template>
  <figure>
    <blockquote class="blockquote">
      <p>{{ block.value.text }}</p>
    </blockquote>
    <figcaption class="blockquote-footer">
      <cite title="Source Title">{{ block.value.attribute_name }}</cite>
    </figcaption>
  </figure>
</template>
<script lang="ts" setup>
import {SphereBlock} from '@/stores/apolloPlatform/cores/portalNavigation';
// https://getbootstrap.com/docs/5.3/content/typography/#naming-a-source
defineProps<{block: SphereBlock<'block_quote'>}>();
</script>
